<template>
    <el-dialog class="popup popup--success"
               :width="windowWidth > 992 ? '770px' : '75%'"
               top="50vh"
               :append-to-body="true"
               :show-close="false"
               :visible.sync="showMessage">
        <div class="popup__success">
            <span><a :href="pageHref" target="_blank">{{ $lang('user.addPage.existsPageMessage.link.part1') }}</a> {{ $lang('user.addPage.existsPageMessage.link.part2') }}
                <br>
                {{ $lang('user.addPage.existsPageMessage.link.part3') }} <a :href="prefix + '/contacts?category=6'" target="_blank" >{{ $lang('user.addPage.existsPageMessage.link.part4') }}</a>.</span>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "ExistsPageMessage",
    props: ['value'],
    data: () => ({
        showMessage: false,
        pageHref: null,
        isResponsible: window.laravel.isResponsible,
        prefix: window.laravel.prefix
    }),
    watch: {
        value: {
            handler: function (value) {
                if (value) {
                    for (let errorName in value.errors) {
                        if (errorName !== 'page_exists') {
                            continue;
                        }

                        if (this.isResponsible) {
                            this.pageHref = value.errors.page_exists[1];

                            this.showMessage = true;
                        } else {
                            this.$appNotify.error(value);
                        }
                    }
                }
            },
            immediate: true
        }
    },
}
</script>
